const masteringES = {
    "view": {
        "table": {
            "title": "Tu Lista de Masterización",
            "column": {
                "created_by": "Creado Por",
                "total_songs": "Número de Canciones",
                "mastered_songs": "Total de Canciones Masterizadas",
                "created": "Fecha de Creación",
                "action": "Acción"
            },
            "button": {
                "open": "ABRIR",
                "edit": "EDITAR",
                "export_csv": "Exportar CSV"
            },
            "placeholder": {
                "search": "Buscar..."
            }
        },
        "message": {
            "noAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información.",
            "subscriptionExpired": "Tu suscripción ha expirado. Por favor <1>reanuda</1> tu suscripción para disfrutar de esta función.",
            "subscriptionUpgrade": "Tu plan de suscripción actual no soporta esta función. Por favor <1>actualiza</1> tu plan de suscripción para disfrutar de esta función.",
            "noCredits": "No te quedan créditos de masterización de audio. Encuentra más sobre los créditos <1>aquí</1> y por favor contacta a nuestro equipo de soporte.",
            "learnMore": "Aprende todo sobre la Masterización de Audio <1>aquí</1>. Para más información y <3>créditos</3>, por favor contacta a nuestro equipo de soporte."
        }
    },
    "add": {
        "form": {
            "step1": {
                "title": "¿Cuántas canciones deseas masterizar?",
                "label": {
                    "number_of_songs": "Número de Canciones"
                },
                "option": {
                    "songsCount": {
                        "selectNoOfSongs": "Selecciona el número de canciones",
                        "song": "Canción",
                        "songs": "Canciones"
                    }
                },
                "button": {
                    "continue": "Continuar"
                }
            },
            "step2": {
                "title": "Selecciona tus canciones para masterizar",
                "button": {
                    "save": "Guardar"
                }
            }
        },
        "message": {
            "uploadSuccess": "¡Canciones de Masterización de Audio Subidas Exitosamente!",
            "creationSuccess": "¡La Masterización de Audio ha sido creada! Ahora por favor selecciona tus canciones en la sección de abajo.",
            "error": "Ocurrió un error. Por favor intenta de nuevo."
        },
        "modal": {
            "addMastering": {
                "header": "¿Estás seguro de que deseas agregar nueva masterización?",
                "body": "Nota: Esto resultará en la deducción de {{credits}} créditos."
            },
            "saveMastering": {
                "header": "¿Estás seguro de que deseas guardar la Masterización de Audio?",
                "body": "Nota: Por favor asegúrate de subir archivos de audio correctos ya que no pueden ser modificados una vez guardados."
            }
        }
    },
    "update": {
        "form": {
            "label": {
                "selectSongs": "Selecciona tus canciones para masterizar"
            },
            "button": {
                "save": "Guardar"
            }
        },
        "message": {
            "success": "¡Masterización de Audio actualizada exitosamente!",
            "errorCantUpdate": "¡La Masterización de Audio no puede ser actualizada una vez que las canciones están subidas!",
            "errorMasteringDoesNotExist": "¡La masterización no puede ser actualizada ya que no existe!",
            "error": "Ocurrió un error. Por favor intenta de nuevo."
        },
        "modal": {
            "saveMastering": {
                "header": "¿Estás seguro de que deseas guardar la Masterización de Audio?",
                "body": "Nota: Por favor asegúrate de subir archivos de audio correctos ya que no pueden ser modificados una vez guardados."
            }
        }
    },
    "viewSongs": {
        "title": "Canciones de Masterización de Audio",
        "table": {
            "column": {
                "name": "Nombre",
                "preset": "Preajuste",
                "intensityAndLoudness": "Intensidad y Sonoridad",
                "preview": "Vista Previa",
                "master": "Master",
                "previewResult": "Resultado de Vista Previa",
                "masteringResult": "Resultado de Masterización",
                "mastered": "Masterizado",
                "action": "Acción"
            },
            "label": {
                "previewAttemptsLeft": "{{count}} Restantes",
                "notAvailable": "No Disponible"
            },
            "button": {
                "generate": "Generar",
                "edit": "Editar",
                "exportCsv": "Exportar CSV"
            },
            "option": {
                "preset": {
                    "acoustic": "Acústico",
                    "allGenres": "Todos los Géneros",
                    "classical": "Clásico",
                    "clubHouseTechno": "Club - House - Techno",
                    "edmMusic": "Música EDM",
                    "electronic": "Electrónica",
                    "electronicRaw": "Electrónica Cruda",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Música Pop",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Enfocado en Voces"
                }
            },
            "message": {
                "previewDownloadTooltip": "La vista previa se está generando. Por favor permite 5-6 minutos para que aparezca.",
                "masteringDownloadTooltip": "La masterización está en proceso. Por favor permite 7-15 minutos para que aparezca.",
                "alreadyMasteredTooltip": "Esta canción ya está masterizada."
            }
        },
        "message": {
            "error": "¡Algo salió mal! Por favor actualiza la página e intenta de nuevo.",
            "successMaster": "¡Canción enviada para generación de Masterización!<br/>Nota: Por favor revisa en unos minutos ya que toma de 7 a 15 minutos generar la masterización.",
            "successPreview": "¡Canción enviada para generación de Vista Previa de Masterización!<br/>Nota: Por favor revisa en unos minutos ya que toma de 5 a 6 minutos generar la vista previa de la masterización."
        },
        "modal": {
            "generateMastering": {
                "header": "Generar Masterización",
                "body": "¿Estás seguro de que deseas generar la masterización? ¡Esta es una acción irreversible! El resultado del master aparecerá en 7-15 minutos.",
                "message": {
                    "success": "¡Canción enviada para generación de Masterización!"
                }
            },
            "generateMasteringPreview": {
                "header": "Generar Vista Previa de Masterización",
                "body": "¿Estás seguro de que deseas generar la vista previa de la masterización? El resultado de la vista previa aparecerá en 5-6 minutos",
                "message": {
                    "success": "¡Canción enviada para generación de Vista Previa de Masterización!"
                }
            }
        }
    },
    "songParametersUpdate": {
        "title": "Editar Parámetros de la Canción",
        "form": {
            "label": {
                "intensity": "Intensidad",
                "loudness": "Sonoridad",
                "preset": "Preajuste"
            },
            "placeholder": {
                "preset": "Selecciona Preajuste"
            },
            "option": {
                "preset": {
                    "acoustic": "Acústico",
                    "allGenres": "Todos los Géneros",
                    "classical": "Clásico",
                    "clubHouseTechno": "Club - House - Techno",
                    "edmMusic": "Música EDM",
                    "electronic": "Electrónica",
                    "electronicRaw": "Electrónica Cruda",
                    "hipHop": "Hip Hop",
                    "hipHopBass": "Hip Hop Bass",
                    "popMusic": "Música Pop",
                    "popRnB": "Pop & RnB",
                    "rockMetal": "Rock & Metal",
                    "trap": "Trap",
                    "vocalFocused": "Enfocado en Voces"
                }
            },
            "button": {
                "submit": "Enviar"
            },
            "message": {
                "intensityTooltip": "La cantidad de dinámica, EQ y procesamiento aplicado a tu canción en relación con la pista general y el preajuste seleccionado. La utilización máxima ocurrirá al 100 %. Recomendamos experimentar con esta configuración para encontrar el punto óptimo que mejor se adapte a ti.",
                "loudnessTooltip": "El nivel objetivo de sonoridad integrada. Medido en unidades de sonoridad relativas a la escala completa (LUFS). Recomendamos experimentar con esta configuración para encontrar el punto óptimo que mejor se adapte a ti. Dependiendo del estilo y género de tu canción, los mejores resultados deberían aparecer entre -15 y -9 db"
            }
        },
        "message": {
            "success": "¡Los parámetros de la canción han sido actualizados!",
            "error": "¡Algo salió mal! Por favor actualiza la página e intenta de nuevo.",
            "songMastered": "¡Los parámetros de la canción no pueden ser actualizados una vez que la canción ha sido masterizada!"
        }
    },
    "songRow": {
        "label": {
            "songs": "Canciones",
            "name": "Nombre",
            "genre": "Género",
            "preset": "Preajuste",
            "intensity": "Intensidad",
            "loudness": "Sonoridad",
            "audioFile": "Archivo de Audio"
        },
        "placeholder": {
            "name": "ej. Nombre de la Canción",
            "genre": "ej. Pop",
            "preset": "Selecciona Preajuste"
        },
        "option": {
            "preset": {
                "acoustic": "Acústico",
                "allGenres": "Todos los Géneros",
                "classical": "Clásico",
                "clubHouseTechno": "Club - House - Techno",
                "edmMusic": "Música EDM",
                "electronic": "Electrónica",
                "electronicRaw": "Electrónica Cruda",
                "hipHop": "Hip Hop",
                "hipHopBass": "Hip Hop Bass",
                "popMusic": "Música Pop",
                "popRnB": "Pop & RnB",
                "rockMetal": "Rock & Metal",
                "trap": "Trap",
                "vocalFocused": "Enfocado en Voces"
            }
        },
        "message": {
            "intensityTooltip": "La cantidad de dinámica, EQ y procesamiento aplicado a tu canción en relación con la pista general y el preajuste seleccionado. La utilización máxima ocurrirá al 100 %. Recomendamos experimentar con esta configuración para encontrar el punto óptimo que mejor se adapte a ti.",
            "loudnessTooltip": "El nivel objetivo de sonoridad integrada. Medido en unidades de sonoridad relativas a la escala completa (LUFS). Recomendamos experimentar con esta configuración para encontrar el punto óptimo que mejor se adapte a ti. Dependiendo del estilo y género de tu canción, los mejores resultados deberían aparecer entre -15 y -9 db",
            "audioFileTooltip": "Los formatos de audio compatibles son: AAC, AIFF, FLAC, MP3, OPUS, VORBIS y WAV. Recomendamos encarecidamente usar tipos de archivos sin pérdida como AIFF, FLAC o WAV. Nuestra herramienta de masterización siempre devolverá el mismo tipo de archivo que el archivo original. Ten en cuenta que necesitas un archivo WAV de 16 bits, 44.1 kHz para la distribución.",
            "errorSongNameRequired": "Por favor ingresa el nombre de la canción",
            "errorSongNameLength": "El nombre de la canción no debe tener más de 80 caracteres.",
            "errorGenreRequired": "Por favor ingresa el género de la canción",
            "errorGenreLength": "El género de la canción no debe tener más de 50 caracteres.",
            "errorPresetRequired": "Debe seleccionarse un preajuste.",
            "errorAudioFileRequired": "Por favor selecciona el archivo de la canción",
            "errorAudioFileValid": "Por favor sube un archivo de audio válido"
        }
    },
    "masteringConfirmModal": {
        "header": "¿Estás seguro de que deseas guardar la Masterización de Audio?",
        "body": "Nota: Por favor asegúrate de subir archivos de audio correctos ya que no pueden ser modificados una vez guardados.",
        "button": {
            "cancel": "Cancelar",
            "confirm": "Confirmar"
        },
        "message": {
            "error": "¡Algo salió mal! Por favor actualiza la página e intenta de nuevo."
        }
    }
};

export default masteringES;